module.exports = __webpack_public_path__ + "static/enterprise-1371cab7d85520e0ef6e91ea14be285d.png";